
export default {
    name: "BlogSidebarLayout",
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
          sidebarActive: false
        };
    },
    computed: {},
    methods: {
      toggleSidebar() {
        this.sidebarActive = !this.sidebarActive;
      },
      closeSidebar() {
        this.sidebarActive = false;
      },
    },
}
